export const REPORT = {
  GRIDCOLUMNS_report_reportHistory_reportHistoryList:
    'GRIDCOLUMNS_report_reportHistory_reportHistoryList',
  GRIDCOLUMNS_report_reportExport_reportExportList:
    'GRIDCOLUMNS_report_reportExport_reportExportList',
  GRIDCOLUMNS_report_reportExport_dashboardExportList:
    'GRIDCOLUMNS_report_reportExport_dashboardExportList',
  GRIDCOLUMNS_report_reportExport_businessExportList:
    'GRIDCOLUMNS_report_reportExport_businessExportList',
  GRIDCOLUMNS_report_reportExport_templateReportList:
    'GRIDCOLUMNS_report_reportExport_templateReportList',
  FILTERSEARCH_report_reportHistory_reportHistoryList:
    'FILTERSEARCH_report_reportHistory_reportHistoryList',
  FILTERSEARCH_report_reportExport_reportList: 'FILTERSEARCH_report_reportExport_reportList',
  FILTER_dashboard_report_export: 'FILTER_dashboard_report_export',
  FILTER_export_business_report: 'FILTER_export_business_report',
  FILTER_export_dashboard_monitoring: 'FILTER_export_dashboard_monitoring',
  FILTER_export_dashboard_reportList: 'FILTER_export_dashboard_reportList',
  FILTER_export_business_reportList: 'FILTER_export_business_reportList',
  FILTER_template_report_export: 'FILTER_template_report_export',
  FILTER_export_template_reportList: 'FILTER_export_template_reportList',
  QUICK_FILTER_export_report_window: 'QUICK_FILTER_export_report_window',
} as const;
